import { createFileRoute } from '@tanstack/react-router';

import { ensureRecord } from '@/app/guards';
import { EmployerCategoriesPage, bankQuery, employerCategoriesQuery } from '@/features/banks-products';
import { NotFoundView } from '@/features/shell';

export const Route = createFileRoute('/_app/banks/$bankId/employer-categories')({
  loader: async ({ context, params }) => {
    const [bank] = await Promise.all([ensureRecord(context.queryClient.query({ ...bankQuery(params.bankId), staleTime: 'static' })), context.queryClient.query({ ...employerCategoriesQuery(params.bankId), staleTime: 'static' })]);
    return { crumb: bank.name };
  },
  notFoundComponent: function BankNotFound() {
    const { bankId } = Route.useParams();
    return <NotFoundView reference={bankId} />;
  },
  component: function BankCatalog() {
    const { bankId } = Route.useParams();
    return <EmployerCategoriesPage bankId={bankId} />;
  },
});
